import React from "react";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const Loader = () => {
  // const { pathname } = useLocation();
  // const [loader, setLoader] = useState(true);

  // useEffect(() => {
  //   if (pathname) {
  //     setLoader(true);
  //     const timer = setTimeout(() => {
  //       setLoader(false);
  //     }, 500);
  //     return () => {
  //       clearTimeout(timer);
  //     };
  //   }
  // }, [pathname]);

  return (
    <>
      {
        <div className="Loader_loaderContainer__cu8Gt">
          <div className="Loader_loader___QBQ5">
            <div className="Loader_loaderImage__1yXsK"></div>
            <div className="Loader_loaderBorder__jbLXv"></div>
          </div>
        </div>
      }
    </>
  );
};

export default Loader;
